module.exports = __webpack_public_path__ + "img/17807377.543c491f.png";